"use client"

import { Sparkles } from "lucide-react"
import { useContext } from "react"
import { Button } from "@/components/ui/button"
import { ChatContext } from "@/lib/ai-chat/chat-context"
import { useTranslation } from "@/lib/i18n"

/**
 * HeaderAskAi — shadcn button with Sparkles icon + "Ask AI" label.
 * Renders inline (no fixed positioning of its own — that's the parent's job
 * via HeaderControls). Hidden when chat is open or no ChatProvider in scope.
 */
export function HeaderAskAiButton() {
  const ctx = useContext(ChatContext)
  const { t } = useTranslation()

  if (!ctx) return null
  if (ctx.companionMode !== "closed") return null

  return (
    <Button
      variant="outline"
      size="sm"
      aria-label={t("nav.askAi")}
      aria-keyshortcuts="Meta+k Control+k"
      data-testid="header-ask-ai-button"
      onClick={() => ctx.setCompanionMode("drawer")}
      className="gap-2 shadow-sm"
    >
      <Sparkles className="h-4 w-4" />
      {t("nav.askAi")}
    </Button>
  )
}
